import {
  measurement,
  consumerSchema,
  avpMeteringPointScheme,
} from '../../schemas';
import * as actionTypes from '../../constants/consumptionPointActionTypes';
import { identity } from 'lodash';
import { meteringPointFields } from '../../constants/meteringPoint';
import { v4 as uuidv4 } from 'uuid';
import { createAsyncAction, normalizeHelper } from '../../utils/asyncHelpers';
import { meteringPointDataSource } from '../../constants/classificators';
import {
  consumptionPointUpdateOrAdd,
  avpConsumerPointsFetch,
  consumerFetch,
} from '../actionHelpers/endpoints';
import {
  toggleCreateForm,
  selectPoint as selectPointPure,
  consumerAdded as consumerAddedPure,
  selectOwner as selectOwnerPure,
  resetFields as resetFieldsPure,
} from '../pureActions/consumptionPointActions';

export const resetFields = () => (dispatch) => dispatch(resetFieldsPure());

export const fetchAvpPoints = createAsyncAction(
  actionTypes.AVP_POINTS_FETCH,
  avpConsumerPointsFetch,
  normalizeHelper([avpMeteringPointScheme])
);

export const createConsumptionPoint = createAsyncAction(
  actionTypes.CONSUMPTION_POINT_CREATE,
  identity,
  normalizeHelper(measurement)
);

export const closePointForm = () => (dispatch) => {
  dispatch(toggleCreateForm(false));
};

export const updateOrAddConsumptionPoint = createAsyncAction(
  actionTypes.CONSUMPTION_POINT_ADD_UPDATE,
  consumptionPointUpdateOrAdd,
  normalizeHelper(measurement)
);

export const editProductionUnitMeasurement = createAsyncAction(
  actionTypes.CONSUMPTION_POINT_EDIT,
  identity,
  normalizeHelper(measurement)
);

export const fetchConsumer = createAsyncAction(
  actionTypes.CONSUMER_FETCH,
  consumerFetch,
  normalizeHelper(consumerSchema)
);

export const selectOwner = (id) => (dispatch) => dispatch(selectOwnerPure(id));

export const submitPointForm = (values) => (dispatch) => {
  if (values[meteringPointFields.ID]) {
    if (values[meteringPointFields.CONSUMER]) {
      dispatch(updateOrAddConsumptionPoint(values));
    } else {
      dispatch(editProductionUnitMeasurement(values));
    }
  } else {
    dispatch(
      createConsumptionPoint({
        ...values,
        [meteringPointFields.ID]: uuidv4(),
        [meteringPointFields.DATA_SOURCE]: meteringPointDataSource.VIRTUAL,
      })
    );
  }
  dispatch(closePointForm());
};

export const consumerAdded = (id) => (dispatch) =>
  dispatch(consumerAddedPure(id));

export const showPointForm = () => (dispatch) =>
  dispatch(toggleCreateForm(true));

export const selectPoint = (pointId) => (dispatch) =>
  dispatch(selectPointPure(pointId));
